import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import Dialog from '@material-ui/core/Dialog';

export interface LoginAlertProps {
    title?: string;
    message?: string;
    onConfirm?: () => void;
}

const styles = {
    modal: {
        width: 600,
    },
    content: {
        padding: '20px',
    },
};

export const LoginAlert: React.FC<LoginAlertProps> = ({
    title = 'Login Error',
    message = 'Sorry, we ran into an issue.  Please login and try again.',
    onConfirm,
}) => {
    const handleConfirm = useCallback(() => {
        onConfirm && onConfirm();
        removeModal();
    }, [onConfirm]);

    return (
        <Dialog
            maxWidth='lg'
            open={true}
            onClose={handleConfirm}
            data-testid='apply-alert-dialog'
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex={-1}
                    role='dialog'
                    style={styles.modal}
                >
                    <div
                        className='page-header'
                        role='banner'
                    >
                        <h1>{title}</h1>
                        <button
                            type='button'
                            className='close'
                            data-dismiss='modal'
                            aria-label='Close'
                            onClick={handleConfirm}
                        >
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    <div
                        className='modal-dialog'
                        role='document'
                        style={styles.content}
                        dangerouslySetInnerHTML={{ __html: message }}
                    ></div>
                    <div className='button-group'>
                        <button
                            onClick={handleConfirm}
                            className='button'
                            aria-label='OK'
                        >
                            Log in again
                        </button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

const mountPointId = 'bfi-apply-loginalert-modal';

// the ignore below are because really the branch being ignored is providing
// arguably over-zealous protection against throwing null-ref exceptions when something
// in the browser has just gone horribly wrong, but really can't be tested
const removeModal = () => {
    const mountPoint = document.getElementById(mountPointId);
    /* istanbul ignore else */
    if (mountPoint) {
        ReactDOM.unmountComponentAtNode(mountPoint);
        mountPoint.parentNode.removeChild(mountPoint);
    }
};

export const loginAlertModal = (props: LoginAlertProps): void => {
    let mountPoint = document.getElementById(mountPointId);
    // istanbul ignore if
    if (mountPoint) {
        ReactDOM.render(<LoginAlert {...props} />, mountPoint);
    } else {
        mountPoint = document.createElement('div');
        mountPoint.id = mountPointId;
        document.body.appendChild(mountPoint);
        ReactDOM.render(<LoginAlert {...props} />, mountPoint);
    }
};
